import { makeAutoObservable } from "mobx";

// 用户配置项来自 getInfo，用于保存个人页面偏好。
export interface UserSetting {
  id: number;
  settingsKey: string;
  settingsName: string;
  settingsValue: string;
  updatedTime: string;
  userId: number;
}

const userStore = makeAutoObservable({
  token: "",
  tenant: "",
  nickName: "",
  userId: "",
  roles: [] as string[],
  settings: [] as UserSetting[],

  SET_USERID(userId: string) {
    this.userId = userId;
  },
  SET_TOEKN(token: string) {
    this.token = token;
  },
  SET_TENANT(tenant: string) {
    this.tenant = tenant;
  },
  SET_NICKNAME(nickName: string) {
    this.nickName = nickName;
  },
  SET_ROLES(roles: string[]) {
    this.roles = roles
  },
  // 保存用户个性化配置，供页面读取默认排序等偏好。
  SET_SETTINGS(settings: UserSetting[]) {
    this.settings = settings;
  },
  SET(data: any) {
    Object.assign(this, data);
  },
  async FETCH() {
    // const resData = await getInfo();
    // this.account = resData.user.imUid;
  },
  CLEAR() {
    // this.token = "";
    // this.account = "";
  },
});

export { userStore };
